module.exports = __webpack_public_path__ + "assets/b87ab9d4ebb8b0251c9be3d70c4831fa.icon_info.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/icon_info.svg
 ** module id = 319
 ** module chunks = 0
 **/